<template>
  <div>
    <input
      v-model.trim="search"
      ref="search"
      type="text"
      :placeholder="$t('luckyDrawAvailableItem.searchItemList')"
      class="form-control"
    />
    <div class="ts-mt-3 ts-border ts-border-gray-300 ts-p-3 ts-rounded max-h">
      <ts-loading-banner :loading="loading">
        <table class="ts-w-full">
          <thead>
            <tr>
              <th class="ts-bg-gray-200 ts-px-2 ts-py-1">
                {{ $t('luckyDrawAvailableItem.itemNameEn') }}
              </th>
              <th class="ts-bg-gray-200 ts-px-2 ts-py-1">
                {{ $t('luckyDrawAvailableItem.itemNameKh') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(pro, index) in this.getItem({
                chosenItem: model.item_list,
                search: search
              })"
              :key="index"
              class="ts-cursor-pointer hover:ts-bg-gray-300"
            >
              <td
                @click="addItem(pro)"
                class="ts-whitespace-no-wrap ts-px-2 ts-py-1"
              >
                {{ pro.item_name_en }}
              </td>
              <td @click="addItem(pro)" class="ts-px-2 ts-py-1">
                {{ pro.item_name_kh }}
              </td>
            </tr>
          </tbody>
        </table>
      </ts-loading-banner>
    </div>
    <small
      ><i>{{ $t('luckyDrawAvailableItem.clickToAddItem') }}</i></small
    >
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'modalSearchToAddProduct',
  props: ['value'],
  data () {
    return {
      model: {},
      loading: false,
      search: ''
    }
  },
  computed: {
    ...mapGetters('luckyDraw/luckyDrawAvailableItem', ['findItem', 'getItem'])
  },
  created () {
    this.model = this.value
    this.$nextTick(() => {
      this.$refs.search.focus()
    })
  },
  methods: {
    addItem (item) {
      let newRow = {
        item_id: item.item_id,
        item_name_en: item.item_name_en,
        item_name_kh: item.item_name_kh,
        quantity: 0
      }

      this.model.item_list.push(_.clone(newRow))
      this.$nextTick(() => {
        this.$refs.search.focus()
        this.$refs.search.select()
      })
    }
  }
}
</script>

<style scoped>
.max-h {
  min-height: 50vh;
  max-height: 60vh;
  overflow: scroll;
}
</style>
